export const Currencies = {
  AUD: _TL_('Australian Dollar'),
  BRL: _TL_('Brazilian Real'),
  CAD: _TL_('Canadian Dollar'),
  CHF: _TL_('Swiss Franc'),
  DKK: _TL_('Danish Krone'),
  EUR: _TL_('EURO'),
  GBP: _TL_('UK Pound'),
  JPY: _TL_('Japanese Yen'),
  NOK: _TL_('Norwegian Krone'),
  NZD: _TL_('New Zealand Dollar'),
  SEK: _TL_('Swedish Krona'),
  USD: _TL_('US Dollar'),
  ZAR: _TL_('South African Rand'),
  ARS: _TL_('Argentine Peso'),
  CLP: _TL_('Chilean Peso'),
  CNY: _TL_('Yuan Renminbi'),
  COP: _TL_('Colombian Peso'),
  CRC: _TL_('Costa Rican Colon'),
  CZK: _TL_('Czech Koruna'),
  DOP: _TL_('Dominican Peso'),
  GTQ: _TL_('Quetzal'),
  HKD: _TL_('Hong Kong Dollar'),
  HNL: _TL_('Lempira'),
  HRK: _TL_('Croatian kuna'),
  HUF: _TL_('Forint'),
  IDR: _TL_('Indonesian Rupiah'),
  INR: _TL_('Indian Rupee'),
  ISK: _TL_('Iceland Krona'),
  KRW: _TL_('Won'),
  MKD: _TL_('Macedonian Dinar'),
  MNT: _TL_('Tugrik'),
  MXN: _TL_('Mexican Peso'),
  MYR: _TL_('Malaysian Ringgit'),
  BND: _TL_('Brunei Dollar'),
  BOB: _TL_('Boliviano'),
  PAB: _TL_('Balboa'),
  PEN: _TL_('Peruvian Nuevo Sol'),
  PHP: _TL_('Philippine Peso'),
  PLN: _TL_('Zloty'),
  PYG: _TL_('Guarani'),
  ALL: _TL_('Albanian Lek'),
  SGD: _TL_('Singapore Dollar'),
  THB: _TL_('Thai Baht'),
  TTD: _TL_('Trinidad and Tobago Dollar'),
  TWD: _TL_('New Taiwan Dollar'),
  UYU: _TL_('Peso Uruguayo'),
  VEF: _TL_('Bolivar Fuerte'),
  VND: _TL_('Vietnamese Dong'),
  TRY: _TL_('New Turkish Lira'),
  BGN: _TL_('Bulgarian Lev'),
  LKR: _TL_('Sri Lanka Rupee'),
  FJD: _TL_('Fiji Dollar'),
  XCD: _TL_('East Caribbean Dollar'),
  RON: _TL_('Romanian New Leu'),
  RSD: _TL_('Serbian Dinar'),
  BAM: _TL_('Bosnian Convertible Marka'),
  VES: _TL_('Venezuelan Bolivar'),
  AWG: _TL_('Aruban Florin'),
  BSD: _TL_('Bahamian Dollar'),
  KYD: _TL_('Cayman Islands Dollar'),
  GYD: _TL_('Guyanese dollar'),
  HTG: _TL_('Haitian gourde'),
  BDT: _TL_('Bangladeshi taka'),
  XPF: _TL_('CFP franc'),
  MVR: _TL_('Maldivian rufiyaa'),
  NPR: _TL_('Nepalese rupee'),
  PGK: _TL_('Papua New Guinean kina'),
  CDF: _TL_('Congolese franc'),
  ETB: _TL_('Ethiopian Birr'),
  GNF: _TL_('Guinean franc'),
  MGA: _TL_('Malagasy Ariary'),
  MWK: _TL_('Kwacha'),
  MRU: _TL_('Mauritanian ouguiya'),
  MUR: _TL_('Mauritian rupee'),
  NGN: _TL_('Naira'),
  SCR: _TL_('Seychelles Rupee'),
  TZS: _TL_('Tanzanian Shilling'),
  GMD: _TL_('Gambian Dalasi'),
  XOF: _TL_('West African CFA franc'),
  DZD: _TL_('Algerian Dinar'),
  AMD: _TL_('Armenian dram'),
  AZN: _TL_('Azerbaijani Manat'),
  BHD: _TL_('Bahraini Dinar'),
  EGP: _TL_('Egyptian Pound'),
  GEL: _TL_('Georgian Lari'),
  IQD: _TL_('Iraqi dinar'),
  ILS: _TL_('Israeli Shekel'),
  KGS: _TL_('Kyrgystani Som'),
  LYD: _TL_('Libyan dinar'),
  MDL: _TL_('Moldovan Leu'),
  OMR: _TL_('Omani rial'),
  PKR: _TL_('Pakistani rupee'),
  QAR: _TL_('Qatari Riyal'),
  TJS: _TL_('Somoni'),
  AED: _TL_('United Arab Emirates dirham'),
  YER: _TL_('Yemeni Rial'),
  SAR: _TL_('Saudi Riyal'),
  XAF: _TL_('CFA Franc BEAC'),
  RWF: _TL_('Rwandan franc'),
  SOS: _TL_('Somali shilling'),
  UGX: _TL_('Uganda new shilling'),
  ZMW: _TL_('Zambian Kwacha'),
  BWP: _TL_('Botswana pula'),
  TND: _TL_('Tunisian dinar'),
  BMD: _TL_('Bermudian dollar'),
  GIP: _TL_('Gibraltar pound'),
  BBD: _TL_('Barbados dollar'),
  BZD: _TL_('Belize dollar'),
  JMD: _TL_('Jamaican dollar'),
  SRD: _TL_('Suriname dollar'),
  TOP: _TL_('Tongan pa\'anga'),
  KMF: _TL_('Comoros franc'),
  DJF: _TL_('Djibouti franc'),
  ERN: _TL_('Eritrean nakfa'),
  WST: _TL_('Samoan tala'),
  SLE: _TL_('Sierra Leonean Leones'),
  VUV: _TL_('Vanuatu vatu'),
};
